module.exports = __webpack_public_path__ + "static/assets/d1d9d198fdd057f2ccc2f632f130506b.svg";